import {createFetchableSlice} from '../../../utils/createFetchableSlice';
import {fetchContracts} from '../../../Api';

export const contractSlice = createFetchableSlice({
    name: 'contracts',
    fetchable: fetchContracts
});

export default contractSlice.reducer;